<template>
          <li>
            <a href="#" class="trash" @click="removeItemFromCart(item)" v-if="!is_old_cart_item(item._id)">
              <svg width="22" height="22" fill="none">
                <use xlink:href="#trash" />
              </svg>
            </a>
            <div class="detail">
              <h6>{{_T_DB(item, 'name')}} <span>{{currency}} {{ Num.price(item.collectivePrice) }}</span></h6>
              <p v-for="(modifier, key) in item.modifiers" :key="key">
                   {{ _T_DB(modifier, 'name') }}
              </p>
              <a
                v-if="!is_old_cart_item(item._id)"
                @click="selectItem()" data-toggle="modal" href="#"
                >
                {{_T('Customize')}}
                <svg width="8" height="4" fill="none">
                  <use xlink:href="#CartEdit" />
                </svg>
              </a>
            </div>
            <QtyBox  v-if="!is_old_cart_item(item._id)"  :qty="item.quantity || 1" :index="item.index" :isCart="true"></QtyBox>
          </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QtyBox from '../QtyBox'
export default {
  props: { item: Object },
  computed: {
    ...mapGetters(['_T', '_T_DB', 'hasModifiers', 'item_modifiers_price', 'is_old_cart_item']),
  },
  components: {
    QtyBox  
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
  methods: {
    ...mapActions(['removeItemFromCart']),
    selectItem() {
      this.$store.commit('SELECT_ITEM', this.item)
      this.$store.commit('SET_ITEM_DETAIL_POPUP', true)
      // this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
  },
}
</script>